import {
  ArdoqEvent,
  isWebSocketBulkDelete,
  isWebSocketCreate,
  isWebSocketDelete,
  isWebSocketUpdate,
} from 'sync/types';
import { ResourceType } from '@ardoq/api-types';
import { ardoqEventOperations } from 'sync/ardoqEventOperations';

// Component, reference and tag events are diverted away from the regular
// routines while in viewpoint mode — they all live on per-loaded-state
// scopeData and the viewpoint-mode routines are the authoritative writers
// (updateComponentsAndReferencesStateRoutine, updateTagsStateRoutine).
//
// Field, model and workspace events are NOT listed here on purpose: even
// though they are also handled by viewpoint-mode routines
// (updateModelsAndWorkspacesStateRoutine for models/workspaces,
// updateFieldsStateRoutine for fields — both keeping per-loaded-state scope
// data in sync), the org-wide field/model/workspace collections must stay
// in sync across the whole organization regardless of any loaded state, so
// the regular routines must keep processing them too.
export const isHandledByViewpointModeRoutines = (
  event: ArdoqEvent<unknown>,
  isViewpointMode: boolean
) => {
  if (!isViewpointMode) {
    return false;
  }
  const isDivertedResource =
    ardoqEventOperations.isOfResourceType(event, ResourceType.COMPONENT) ||
    ardoqEventOperations.isOfResourceType(event, ResourceType.REFERENCE) ||
    ardoqEventOperations.isOfResourceType(event, ResourceType.TAG);
  const isHandledLifecycleEvent =
    isWebSocketCreate(event) ||
    isWebSocketDelete(event) ||
    isWebSocketBulkDelete(event) ||
    isWebSocketUpdate(event);

  return isDivertedResource && isHandledLifecycleEvent;
};

export const isNotHandledByViewpointModeRoutines = (
  event: ArdoqEvent<unknown>,
  { isViewpointMode }: { isViewpointMode: boolean }
): boolean => !isHandledByViewpointModeRoutines(event, isViewpointMode);
